export const VERIFY_DATA_ROWS_PER_PAGE = 100;

export type VerifyDataSearchableRow = {
  groupLabel?: string;
  officeInfo?: {
    name?: string;
  };
  districtInfo?: {
    name?: string;
    longName?: string;
  };
};

const normalizeSearchValue = (value: unknown) => (
  String(value ?? '').trim().toLocaleLowerCase()
);

export const filterVerifyDataRows = <T extends VerifyDataSearchableRow>(
  rows: T[],
  searchText: string
) => {
  const query = normalizeSearchValue(searchText);
  if (!query) return rows;

  return rows.filter(row => [
    row.groupLabel,
    row.officeInfo?.name,
    row.districtInfo?.longName,
    row.districtInfo?.name
  ].some(value => normalizeSearchValue(value).includes(query)));
};

export const getVerifyDataPage = <T>(
  rows: T[],
  page: number,
  rowsPerPage = VERIFY_DATA_ROWS_PER_PAGE
) => {
  const pageCount = Math.max(1, Math.ceil(rows.length / rowsPerPage));
  const safePage = Math.min(Math.max(page, 1), pageCount);
  const startIndex = (safePage - 1) * rowsPerPage;

  return {
    page: safePage,
    pageCount,
    rows: rows.slice(startIndex, startIndex + rowsPerPage),
    firstVisibleRow: rows.length === 0 ? 0 : startIndex + 1,
    lastVisibleRow: Math.min(startIndex + rowsPerPage, rows.length)
  };
};
